<script setup>
  import { computed, onMounted, reactive, ref } from 'vue'
  import { QuestionCircleFilled } from '@ant-design/icons-vue'
  import {
    checkDocMtAuthority,
    checkTextCalculate,
    setUserGetDict,
  } from '@/http/api'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'

  const store = useStore()
  const userInfo = computed(() => store.state.user.userInfo)
  const state = reactive({
    visible: false,
  })

  const emit = defineEmits(['update:loading'])
  const detail = ref({})
  const accountType = userInfo.value.accountType
  const permission = computed(
    () => store.state.comm.enterpriseGlobalObj?.permission || []
  )
  const autoPay = computed({
    set(val) {
      store.commit('user/changeKey', {
        autoPay: val,
      })
    },
    get() {
      return store.state.user.autoPay
    },
  })
  let callbackFunc = () => {}
  let backFunc = () => {}
  const handleOk = () => {
    setUserGetDict({ key: 'automatic-payment', value: `${autoPay.value}` })
    //译力足够
    if (detail.value.isEnough || !detail.value.mustToBilling) {
      callBackStart()
      reset()
    } else {
      if (accountType === 'enterprise') {
        message.error('私有用户暂不支持充值操作，请联系企业创建人处理')
        return
      }
      reset()
      window.open(
        `${window.env.recharge}?enterpriseId=${sessionStorage.getItem('enterpriseId')}`,
        '_blank'
      )
    }
  }

  const onCheckChange = () => {
    setUserGetDict({ key: 'automatic-payment', value: `${autoPay.value}` })
  }

  const callBackStart = () => {
    if (callbackFunc) {
      callbackFunc()
    }
  }

  const handleCancel = () => {
    backFunc()
    reset()
  }

  const init = async (params, cbFunc, bkFunc) => {
    callbackFunc = cbFunc || null
    backFunc = typeof bkFunc === 'function' ? bkFunc : () => {}
    if (userInfo.value && userInfo.value.casId) {
      //如果登录查询权限接口
      if (!permission.value.includes('tc.twinsmt.text')) {
        message.error('您在企业内暂无文本翻译权限，可联系管理员调整权限')
        return
      }

      detail.value = { ...params }
      //译力足够
      if (detail.value.isEnough || !detail.value.mustToBilling) {
        // 回调cbFunc Copy
        //勾选了不再提示,则直接触发
        if (autoPay.value) {
          handleOk()
        } else {
          //反之则打开弹窗，展示详情
          state.visible = true
        }
      } else {
        //译力不足则直接提示弹窗
        state.visible = true
      }
    } else {
      // 如果未登录直接调用接口
      callBackStart()
    }
  }

  //重置所有
  const reset = () => {
    callbackFunc = () => {}
    backFunc = () => {}
    emit('update:loading', false)
    state.visible = false
  }

  defineExpose({ init })
</script>

<template>
  <a-modal
    class="price-modal"
    :visible="state.visible"
    :centered="true"
    :footer="null"
    :maskClosable="false"
    :bodyStyle="{ padding: '20px 30px 0 30px' }"
    @cancel="handleCancel"
  >
    <template #title>
      <div class="title-box">机翻收费提示</div>
    </template>
    <section class="price-box">
      <!-- 非小说组 -->
      <div class="tips font-size-16 color-333" v-if="detail.mustToBilling">
        <!-- 费用足够 -->
        <span v-if="detail.isEnough">
          <!-- 有字数包 -->
          <template v-if="typeof detail.remainingFlowCount == 'number'">
            <!-- 字数包够 -->
            <!-- 字数包为0 -->
            <span v-if="detail.remainingFlowCount == 0">
              翻译 {{ detail.wordCount }} 字数，需支付
              <span class="color-D74590">{{ detail.payEtoken }}</span>
              译力，是否确认支付？
            </span>
            <span v-else-if="detail.payEtoken == 0">
              翻译 {{ detail.wordCount }} 字数，字数包扣除
              <span class="color-D74590">{{ detail.payFlowCount }}</span>
              字数
              <a-tooltip>
                <template #title>
                  温馨提示：字数包规格字数为根据谷歌引擎单价字数计算，不同引擎按照相应的比例抵扣。
                  <span
                    class="color-D74590 cursor-pointer"
                    style="text-decoration: underline"
                    @click="toRecharge"
                  >
                    详情参见字数包计费说明。
                  </span>
                </template>
                <QuestionCircleFilled style="color: #bfbfbf" />
              </a-tooltip>
              ，是否确认支付？
            </span>
            <!-- 字数包不够 -->
            <span
              v-else-if="detail.payEtoken > 0 && detail.remainingFlowCount > 0"
            >
              翻译 {{ detail.wordCount }} 字数，其中字数包扣除
              <span class="color-D74590">{{ detail.payFlowCount }}</span>
              字数
              <a-tooltip>
                <template #title>
                  温馨提示：字数包规格字数为根据谷歌引擎单价字数计算，不同引擎按照相应的比例抵扣。
                  <span
                    class="color-D74590 cursor-pointer"
                    style="text-decoration: underline"
                    @click="toRecharge"
                  >
                    详情参见字数包计费说明。
                  </span>
                </template>
                <QuestionCircleFilled style="color: #bfbfbf" />
              </a-tooltip>
              ，另外需支付
              <span class="color-D74590">{{ detail.payEtoken }}</span>
              译力，是否确认支付？
            </span>
          </template>
          <!-- 无字数包 -->
          <template
            v-else-if="
              typeof detail.remainingFlowCount == 'object' &&
              typeof detail.remainingEtoken == 'number'
            "
          >
            <!-- e力够 -->
            <span v-if="detail.remainingEtoken >= detail.payEtoken">
              翻译 {{ detail.wordCount }} 字数，需支付
              <span class="color-D74590">{{ detail.payEtoken }}</span>
              译力，是否确认支付？
            </span>
          </template>
          <!-- 代付 -->
          <template
            v-else-if="
              typeof detail.remainingFlowCount == 'object' &&
              typeof detail.remainingEtoken == 'object'
            "
          >
            <!-- 有字数包，字数包够 -->
            <span v-if="detail.payFlowCount > 0 && detail.payEtoken == 0">
              翻译 {{ detail.wordCount }} 字数，字数包扣除
              <span class="color-D74590">{{ detail.payFlowCount }}</span>
              字数
              <a-tooltip>
                <template #title>
                  温馨提示：字数包规格字数为根据谷歌引擎单价字数计算，不同引擎按照相应的比例抵扣。
                  <span
                    class="color-D74590 cursor-pointer"
                    style="text-decoration: underline"
                    @click="toRecharge"
                  >
                    详情参见字数包计费说明。
                  </span>
                </template>
                <QuestionCircleFilled style="color: #bfbfbf" />
              </a-tooltip>
              ，是否确认支付？
            </span>
            <!-- 有字数包，字数包不够 -->
            <span v-else-if="detail.payFlowCount > 0 && detail.payEtoken > 0">
              翻译 {{ detail.wordCount }} 字数，其中字数包扣除
              <span class="color-D74590">{{ detail.payFlowCount }}</span>
              字数
              <a-tooltip>
                <template #title>
                  温馨提示：字数包规格字数为根据谷歌引擎单价字数计算，不同引擎按照相应的比例抵扣。
                  <span
                    class="color-D74590 cursor-pointer"
                    style="text-decoration: underline"
                    @click="toRecharge"
                  >
                    详情参见字数包计费说明。
                  </span>
                </template>
                <QuestionCircleFilled style="color: #bfbfbf" />
              </a-tooltip>
              ，另外需支付
              <span class="color-D74590">{{ detail.payEtoken }}</span>
              译力，是否确认支付？
            </span>
            <!-- 无字数包 -->
            <span v-else>
              翻译 {{ detail.wordCount }} 字数，需支付
              <span class="color-D74590">{{ detail.payEtoken }}</span>
              译力，是否确认支付？
            </span>
          </template>
        </span>
        <!-- 费用不足 -->
        <template v-else>
          <!-- 有字数包 -->
          <span
            v-if="
              typeof detail.remainingFlowCount == 'number' &&
              detail.remainingFlowCount > 0
            "
          >
            翻译 {{ detail.wordCount }} 字数，字数包扣除
            <span class="color-D74590">{{ detail.payFlowCount }}</span>
            字数
            <a-tooltip>
              <template #title>
                温馨提示：字数包规格字数为根据谷歌引擎单价字数计算，不同引擎按照相应的比例抵扣。
                <span
                  class="color-D74590 cursor-pointer"
                  style="text-decoration: underline"
                  @click="toRecharge"
                >
                  详情参见字数包计费说明。
                </span>
              </template>
              <QuestionCircleFilled style="color: #bfbfbf" />
            </a-tooltip>
            ，另外需支付
            <span class="color-D74590">{{ detail.payEtoken }}</span>
            译力，余额不足，是否前往充值？
          </span>
          <!-- 代付 -->
          <span
            v-else-if="
              typeof detail.remainingFlowCount == 'object' &&
              typeof detail.remainingEtoken == 'object'
            "
          >
            翻译 {{ detail.wordCount }} 字数，需支付
            <span class="color-00c6f3">{{ detail.payEtoken }}</span>
            译力，余额不足，是否提醒充值？
          </span>
          <!-- 无字数包 -->
          <span v-else>
            翻译 {{ detail.wordCount }} 字数，需支付
            <span class="color-D74590">{{ detail.payEtoken }}</span>
            译力，余额不足，是否前往充值？
          </span>
        </template>
      </div>

      <!-- 小说组，不收费 -->
      <span class="tips font-size-16 color-333" v-else>
        翻译 {{ detail.wordCount }} 字数，需支付
        <span class="color-D74590">{{ detail.payEtoken }}</span>
        译力，是否确认支付？
      </span>
    </section>
    <!-- footer -->
    <div>
      <a-checkbox v-model:checked="autoPay" @change="onCheckChange">
        <span class="color-999">若账户译力充足，则自动扣费</span>
      </a-checkbox>
    </div>
    <div
      class="text-center display-flex align-center justify-between price-footer"
    >
      <div class="display-flex align-center">
        <div
          class="display-flex align-center margin-r-20"
          v-if="detail.remainingFlowCount > 0"
        >
          <img src="@/images/count-icon.png" width="26" />
          <div class="margin-l-5">
            <p class="font-size-12 color-999" style="line-height: 14px">
              字数包（字）
            </p>
            <p
              class="font-size-14 color-333 text-left"
              style="line-height: 17px"
            >
              {{ detail.remainingFlowCount }}
            </p>
          </div>
        </div>
        <div
          class="display-flex align-center"
          v-if="typeof detail.remainingEtoken == 'number'"
        >
          <img src="@/images/e-icon.png" width="26" />
          <div class="margin-l-5">
            <p
              class="font-size-12 color-999 text-left"
              style="line-height: 14px"
            >
              译力（译）
            </p>
            <p
              class="font-size-14 color-333 text-left"
              style="line-height: 17px"
            >
              {{ detail.remainingEtoken }}
            </p>
          </div>
        </div>
      </div>
      <div>
        <a-button
          key="back"
          size="large"
          @click="handleCancel"
          style="width: 120px; margin-right: 10px"
        >
          取消
        </a-button>
        <a-button
          type="primary"
          size="large"
          @click="handleOk"
          style="width: 120px"
        >
          {{
            detail.isEnough || !detail.mustToBilling
              ? '确定'
              : typeof detail.remainingFlowCount == 'object' &&
                  typeof detail.remainingEtoken == 'object'
                ? '确定'
                : '前往充值'
          }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
  .price-footer {
    padding: 28px 0;
  }
  .title-box {
    padding: 10px 0;
  }
  .price-box {
    .item-info {
      padding: 15px;
      width: 270px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #a0ebfc;

      .icon {
        width: 70px;
        height: 70px;

        img {
          width: 100%;
        }
      }

      .info {
        width: 150px;
        margin-left: 15px;

        .title {
          font-size: 14px;
          color: #333;
        }

        .number {
          font-size: 20px;
          font-weight: 600;
        }
      }
    }

    .tips {
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }
  .color-FF453A {
    color: #ff453a;
  }
</style>
